import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { MOBILE_NAMESPACE } from '@/i18n';
import '@/Pages/Mobile/MobilePage.sass';

export function MobileValidationHeader(): JSX.Element {
  const { t } = useTranslation(MOBILE_NAMESPACE);

  return (
    <Box
      component="header"
      className="mobile-validation-header"
      data-testid="mobile-validation-header"
    >
      <Typography
        component="p"
        variant="overline"
        className="mobile-validation-header__identity"
      >
        {t('header.productName')}
      </Typography>

      <Typography
        component="h1"
        variant="h5"
        className="mobile-validation-header__title"
      >
        {t('header.title')}
      </Typography>

      <Typography
        component="p"
        variant="body2"
        className="mobile-validation-header__subtitle"
      >
        {t('header.subtitle')}
      </Typography>
    </Box>
  );
}
